/**
 * Product Item Dynamic Swatches
 * Troca imagem principal, título, preço e link do card ao clicar em swatch de cor
 */

(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-swatch-handle]');
    if (!btn) return;

    var swatchesContainer = btn.closest('[data-pi-swatches]');
    if (!swatchesContainer) return;

    var card = swatchesContainer.closest('[data-product-item]');
    if (!card) return;

    var handle = btn.dataset.swatchHandle;
    var swatchColor = btn.dataset.swatchColor || '';
    var swatchBg = btn.style.backgroundColor || '';
    if (!handle) return;

    // Evita clique duplo ou clique no já ativo
    var currentHandle = card.querySelector('[data-pi-image]');
    currentHandle = currentHandle ? currentHandle.dataset.piHandle : null;
    if (handle === currentHandle) {
      return;
    }

    if (btn.classList.contains('is-loading')) return;

    // Marca todos os swatches do card como loading
    swatchesContainer.querySelectorAll('[data-swatch-handle]').forEach(function (b) {
      b.classList.add('is-loading');
    });

    fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('Produto não encontrado');
        return res.json();
      })
      .then(function (product) {
        updateCard(card, product, handle, swatchColor, swatchBg);

        // Remove loading e marca ativo (usa handle do produto como fallback)
        var productHandle = product.handle || handle;
        swatchesContainer.querySelectorAll('[data-swatch-handle]').forEach(function (b) {
          b.classList.remove('is-loading');
          b.classList.remove('is-active');
          if (b.dataset.swatchHandle === handle || b.dataset.swatchHandle === productHandle) {
            b.classList.add('is-active');
          }
        });
      })
      .catch(function (err) {
        swatchesContainer.querySelectorAll('[data-swatch-handle]').forEach(function (b) {
          b.classList.remove('is-loading');
        });
      });
  });

  function updateCard(card, product, handle, swatchColor, swatchBg) {
    // ===== IMAGEM PRINCIPAL =====
    var mainImg = card.querySelector('[data-pi-image]');
    if (mainImg && product.images && product.images.length > 0) {
      var imgUrl = product.images[0];
      // Força recarregamento adicionando timestamp
      var separator = imgUrl.indexOf('?') !== -1 ? '&' : '?';
      mainImg.src = imgUrl + separator + '_=' + Date.now();
      mainImg.removeAttribute('srcset');
      mainImg.dataset.piHandle = handle;
      mainImg.alt = product.title;
    }

    // ===== LINKS =====
    var links = card.querySelectorAll('[data-pi-link]');
    links.forEach(function (link) {
      link.href = '/products/' + handle;
    });

    // ===== TÍTULO =====
    var title = card.querySelector('[data-pi-title]');
    if (title) title.textContent = product.title;

    // ===== PREÇO =====
    var priceEl = card.querySelector('[data-pi-price]');
    if (priceEl) {
      priceEl.textContent = formatMoney(product.price);
    }

    // ===== PREÇO COMPARATIVO =====
    var compareEl = card.querySelector('[data-pi-compare]');
    if (compareEl) {
      if (product.compare_at_price && product.compare_at_price > product.price) {
        compareEl.textContent = formatMoney(product.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    // ===== QUICK ADD BUTTON =====
    var quickAddBtn = card.querySelector('[data-quick-add-btn]');
    if (quickAddBtn) {
      var firstVariant = product.variants && product.variants[0];
      if (firstVariant) {
        quickAddBtn.dataset.variantId = firstVariant.id;
        quickAddBtn.dataset.productUrl = '/products/' + handle;
        quickAddBtn.disabled = !firstVariant.available;
      }
    }

    // ===== CARD METADATA (para mobile quick-add) =====
    card.dataset.productHandle = product.handle || handle;
    // Atualiza color-map a partir das variantes do novo produto
    var newColorMap = '';
    var newColorVariants = [];
    if (product.options && product.variants) {
      var cIdx = getColorOptionIndex(product);
      if (cIdx >= 0) {
        var seenColors = {};
        for (var vi = 0; vi < product.variants.length; vi++) {
          var v = product.variants[vi];
          var vColor = v.options ? v.options[cIdx] : (v['option' + (cIdx + 1)]);
          if (vColor && !seenColors[vColor]) {
            seenColors[vColor] = true;
            newColorMap += (newColorMap ? ',' : '') + vColor + ':' + vColor.toLowerCase().replace(/\s+/g, '-');
          }
        }
      }
    }
    if (newColorMap) {
      card.dataset.colorMap = newColorMap;
    }

    // ===== PRODUCT JSON (para quick add funcionar com a cor trocada) =====
    var jsonScript = document.querySelector('script[data-product-json-' + card.id + ']');
    if (jsonScript) {
      jsonScript.textContent = JSON.stringify(product);
    }

    // ===== QUICK ADD OPTIONS (re-renderiza opções do novo produto) =====
    updateQuickAddOptions(card, product, swatchColor, swatchBg);
    card.dispatchEvent(new CustomEvent('product:item-updated', { detail: { product: product } }));

    // ===== PARCELAMENTO =====
    var installmentEl = card.querySelector('[data-pi-installment]');
    if (installmentEl) {
      var installmentsCount = parseInt(installmentEl.dataset.piInstallmentsCount, 10) || 3;
      var installmentPrice = Math.floor(product.price / installmentsCount);
      installmentEl.textContent = 'ou ' + installmentsCount + 'x de ' + formatMoney(installmentPrice) + ' sem juros';
    }
  }

  function normalizeProductOptions(product) {
    // O /products/HANDLE.js retorna options como array de strings.
    // Reconstrói objetos { name, values } a partir das variantes.
    if (!product.options || !product.variants) return;
    var normalized = [];
    for (var i = 0; i < product.options.length; i++) {
      var optName = product.options[i];
      if (typeof optName === 'object' && optName.name) {
        // Já está normalizado (ex: JSON embutido no Liquid)
        normalized.push({ name: optName.name, values: optName.values || [] });
        continue;
      }
      var values = [];
      var seen = {};
      for (var v = 0; v < product.variants.length; v++) {
        var variant = product.variants[v];
        // Garante que a variante tenha array options
        if (!variant.options || !variant.options.length) {
          variant.options = [];
          if (variant.option1) variant.options.push(variant.option1);
          if (variant.option2) variant.options.push(variant.option2);
          if (variant.option3) variant.options.push(variant.option3);
        }
        var val = variant.options[i];
        if (val && !seen[val]) {
          seen[val] = true;
          values.push(val);
        }
      }
      normalized.push({ name: optName, values: values });
    }
    product._normalizedOptions = normalized;
  }

  function getColorOptionIndex(product) {
    var opts = product._normalizedOptions || product.options || [];
    for (var i = 0; i < opts.length; i++) {
      var name = (opts[i].name || '').toLowerCase();
      if (name.indexOf('cor') !== -1 || name.indexOf('color') !== -1) {
        return i;
      }
    }
    return -1;
  }

  function updateQuickAddOptions(card, product, swatchColor, swatchBg) {
    var optionsContainer = card.querySelector('[data-quick-add-options]');
    if (!optionsContainer) return;

    normalizeProductOptions(product);

    var colorOptionIndex = getColorOptionIndex(product);
    var opts = product._normalizedOptions || [];

    // Mantém a cor apenas como filtro interno; o overlay exibe só as demais opções.
    var colorName = swatchColor || '';
    if (!colorName && colorOptionIndex >= 0 && product.variants && product.variants.length > 0) {
      var firstVariant = product.variants[0];
      colorName = firstVariant.options ? firstVariant.options[colorOptionIndex] : (firstVariant['option' + (colorOptionIndex + 1)]);
    }
    var html = '';
    for (var optIdx = 0; optIdx < opts.length; optIdx++) {
      if (optIdx === colorOptionIndex) continue;

      var option = opts[optIdx];
      var values = option.values || [];

      html += '<div>';
      html += '<div class="quick-add-option-scroller flex justify-center gap-1.5 p-0.5" data-option-index="' + optIdx + '">';
      for (var j = 0; j < values.length; j++) {
        var isAvailable = optionValueAvailable(product, optIdx, values[j], colorOptionIndex, colorName);
        html += '<button type="button" class="quick-add-option shrink-0 w-8 h-8 text-xs font-medium border border-gray-300 cursor-pointer hover:border-gray-900 rounded-full' + (isAvailable ? '' : ' is-unavailable') + '" data-value="' + escapeHtml(values[j]) + '"' + (isAvailable ? '' : ' disabled aria-disabled="true"') + '>' + escapeHtml(values[j]) + '</button>';
      }
      html += '</div></div>';
    }

    // Botão confirmar
    var confirmBtn = optionsContainer.querySelector('[data-quick-add-confirm]');
    var confirmText = confirmBtn ? confirmBtn.textContent : 'Adicionar ao carrinho';
    html += '<button type="button" class="quick-add-confirm hidden w-full py-2 bg-white/85 border border-white/70 text-gray-900 text-xs font-medium mt-1.5 cursor-pointer hover:bg-white/95 disabled:cursor-not-allowed rounded-xl" data-quick-add-confirm disabled>' + confirmText + '</button>';

    optionsContainer.innerHTML = html;
  }

  function optionValueAvailable(product, optionIndex, value, colorOptionIndex, colorName) {
    if (!product || !product.variants) return true;

    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      if (!variant.available) continue;
      if (!variant.options || !variant.options.length) {
        variant.options = [];
        if (variant.option1) variant.options.push(variant.option1);
        if (variant.option2) variant.options.push(variant.option2);
        if (variant.option3) variant.options.push(variant.option3);
      }
      if (variant.options[optionIndex] !== value) continue;
      if (colorOptionIndex >= 0 && colorName && variant.options[colorOptionIndex] !== colorName) continue;
      return true;
    }

    return false;
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function formatMoney(cents) {
    var value = (cents / 100).toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return 'R$ ' + value;
  }
})();
